export default "__VITE_ASSET__BljK2Tx3__$_?dataurl__"